let URL;
let ORIGIN;
let HEADERS;
let HASH_TOKEN = '';

if (!window.theme.loyalty) {
  URL = 'https://thermomix--loyaltynat.sandbox.my.site.com/event/services/apexrest/Script';
  ORIGIN = 'https://thermomix-au-test.myshopify.com/'
} else {
  URL = window.theme.loyalty.apiUrl;
  ORIGIN = window.theme.loyalty.apiOrigin;
  HASH_TOKEN = window.theme.loyalty.token
}

HEADERS = {
  'Content-Type': 'application/json',
  'Origin': ORIGIN,
  'URI': 'Script',
  "Access-Control-Allow-Origin": ORIGIN,
  "Access-Control-Allow-Methods": "POST",
  "Access-Control-Allow-Headers": "Content-Type",
  "Access-Control-Allow-Credentials": "true",
}

const postData = async (url, process, input) => {
  const data = {
    process: process,
    input: input
  }
  const response = await fetch(url, {
    method: 'POST',
    headers: HEADERS,
    body: JSON.stringify(data)
  });

  return response.json(); // This will return the response body as JSON
}

/**
 * @param { string } firstName
 * @param { string } lastName
 * @param { string } mobileNumber // format +61411223344
 * @param { string } emailAddress
 * @param { string } birthday format DD/MM
 * @param { boolean} paidTier
 * @param { string } countryCode
 * @param { string } programName
 * @param { boolean } termsAndConditions
 * @returns { statuscode, message, membershipNumber, success }
 */
export const enrollMemberToProgram = async (firstName, lastName, mobileNumber, emailAddress, birthday, paidTier, countryCode, programName, termsAndConditions) => {
  const process = 'enrollMemberToProgram'
  const input = {
    firstName: firstName,
    lastName: lastName,
    mobileNumber: mobileNumber,
    emailAddress: emailAddress,
    birthday: birthday,
    paidTier: paidTier,
    countryCode: countryCode,
    programName: programName,
    termsAndConditions: termsAndConditions
  }

  try {
    let data = await postData(URL, process, input)
    if (!data) {
      console.warn('No data found...')
      return null
    }
    if (data.statuscode !== '200') {
      console.warn('Error:', data);
      return data
    }
    return data
  }
  catch (error) {
    console.error('Error:', error);
    return error
  }
};

/**
 *
 * @param membershipNumber { string }
 * @param programName  { string }
 * @returns { object }
 */
export const getMemberProfile = async (membershipNumber, programName) => {
  if (!membershipNumber || !programName) {
    return null
  }
  const process = 'getMemberProfile'
  const input = {
    membershipNumber: membershipNumber,
		programName: programName,
		hashToken: HASH_TOKEN
  }
  try {
    let response = await postData(URL, process, input)
    if (!response || response.success !== true || !response.MemberDetails) {
      console.warn('No data found...')
      return null
    }
    if (response.statuscode !== '200') {
      console.warn('Error:', response.message);
      return null
    }
    return response
  } catch (error) {
    console.error('Error:', error);
    return null
  }
};

/**
 *
 * @param membershipNumber { string }
 * @param programName  { string }
 * @returns { object }
 */
export const getLoyaltyVouchers = async (membershipNumber, programName) => {
  if (!membershipNumber || !programName) {
    return null
  }
  const process = 'getLoyaltyVouchers'
  const input = {
    membershipNumber: membershipNumber,
		programName: programName,
		hashToken: HASH_TOKEN
  }
  try {
    let response = await postData(URL, process, input)
    if (!response || response.success !== true) {
      console.warn('No data found...')
      return null
    }
    if (response.statuscode !== '200') {
      console.warn('Error:', response.message);
      return null
    }
    return response
  } catch (error) {
    console.error('Error:', error);
    return null
  }
};


/**
 *
 * @param membershipNumber { string }
 * @param programName  { string }
 * @returns { object }
 */
export const getLoyaltyTransactions = async (membershipNumber, programName) => {
  if (!membershipNumber || !programName) {
    return null
  }
  const process = 'getLoyaltyTransactions'
  const input = {
    membershipNumber: membershipNumber,
		programName: programName,
		hashToken: HASH_TOKEN
  }

  try {
    let response = await postData(URL, process, input)
    if (!response || response.success !== true) {
      console.warn('No data found...')
      return null
    }
    if (response.statuscode !== '200') {
      console.warn('Error:', response.message);
      return null
    }
    return response
  } catch (error) {
    console.error('Error:', error);
    return null
  }
};


/**
 *
 * @param membershipNumber { string }
 * @param programName  { string }
 * @returns { object }
 */
export const getDetailsAccManagementPage = async (membershipNumber, programName) => {
  if (!membershipNumber || !programName) {
    return null
  }
  const process = 'getDetailsAccManagementPage'
  const input = {
    membershipNumber: membershipNumber,
		programName: programName,
		hashToken: HASH_TOKEN
  }
  try {
    let response = await postData(URL, process, input)
    if (!response || response.success !== true) {
      console.warn('No data found...')
      return null
    }
    if (response.statuscode !== '200') {
      console.warn('Error:', response.message);
      return null
    }
    return response
  } catch (error) {
    console.error('Error:', error);
    return null
  }
};


/**
 *
 * @param membershipNumber { string }
 * @param programName  { string }
 * @param joinLoyalty  { boolean }
 * @returns { object }
 */
export const joinLoyaltyProgram = async (membershipNumber, programName, joinLoyalty) => {
  const process = 'joinLoyaltyProgram'
  const input = {
    joinLoyalty: joinLoyalty,
    membershipNumber: membershipNumber,
		programName: programName,
		hashToken: HASH_TOKEN
  }
  try {
    let response = await postData(URL, process, input)
    if (!response || response.success !== true) {
      console.warn('No data found...')
      return null
    }
    if (response.statuscode !== '200') {
      console.warn('Error:', response.message);
      return null
    }
    return response
  } catch (error) {
    console.error('Error:', error);
    return null
  }
};

/**
 *
 * @param membershipNumber { string }
 * @param programName  { string }
 * @returns { object }
 */
export const retrieveAll = async (membershipNumber, programName) => {
  if (!membershipNumber || !programName) {
    return null
  }
  const process = 'retrieveAll'
  const input = {
    membershipNumber: membershipNumber,
		programName: programName,
		hashToken: HASH_TOKEN
  }
  try {
    let response = await postData(URL, process, input)
    if (!response || response.success !== true) {
      console.warn('retrieveAll: No data found...')
      return null
    }
    return response
  } catch (error) {
    console.error('retrieveAll: Error:', error);
    return null
  }
};